<!--src/Components/Footer/Footer.svelte-->
<script>
  import { navigate } from "svelte-routing";
  import { store } from "../../store";
  export let footerData = {};
  export let white = false;
  let r = $store.r;
  const { COPYRIGHT } = footerData;
  const footerHeight = -200;
</script>

<!------------------------------------------->
<!----------------MARKUP----------------------->
<!------------------------------------------->
<section
  class="main-bgcolor font-roboto"
  id="footer"
  style={`--type:${white ? "#e1e1e1" : "black"}; --type2:${white ? "black" : "#e1e1e1"}`}
  style:top={`${$store.imageHeight * $store.r - footerHeight}px`}
>
  <div class="footer-container">
    <div class="row footer-box ">
      <div
        class="col-md-12 mb-3 p-0 d-flex justify-content-center align-items-center footer-box"
      >
        <span
          class:text-white={white}
          class="sns"
          on:click={() => navigate("https://t.me/Konnectglobal")}
        >
          <svg
            width={`${r * 30}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 84.56 84.56"
            ><defs
              ><style>
                .tele-1 {
                  fill: #bababa;
                }
                .tele-2 {
                  fill: #e1e1e1;
                }
              </style></defs
            ><g id="Layer_2" data-name="Layer 2"
              ><g id="Layer_1-2" data-name="Layer 1"
                ><circle class="tele-1" cx="42.28" cy="42.28" r="42.28" /><path
                  class="tele-2"
                  d="M17.6,41.91,46.07,30.18c2.81-1.22,12.34-5.13,12.34-5.13s4.4-1.71,4,2.44c-.12,1.71-1.1,7.7-2.08,14.18l-3,19.18s-.25,2.81-2.32,3.3-5.5-1.71-6.11-2.2-9.17-5.86-12.34-8.55c-.86-.73-1.84-2.2.12-3.91,4.4-4,9.65-9,12.83-12.22,1.47-1.47,2.93-4.89-3.18-.73L29.08,48.14s-1.95,1.23-5.62.13-7.94-2.57-7.94-2.57-2.93-1.83,2.08-3.79Z"
                /></g
              ></g
            ></svg
          >
        </span>
        <span
          class:text-white={white}
          class="sns"
          on:click={() => navigate("https://www.instagram.com/konnectkct/")}
        >
          <svg 
            version="1.1" 
            xmlns="http://www.w3.org/2000/svg" 
            xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" 
            width={`${r * 30}`} 
            viewBox="0 0 58.34 58.34" 
            style="enable-background:new 0 0 58.34 58.34;" xml:space="preserve">
          <defs
              ><style>
                .insta-1 {
                  fill: #fff;
                }
                .insta-2 {
                  fill: #fff;
                }
              </style></defs
            >
          <g>
          <g>
          <g>
            <path class="insta-1" d="M44.61,10.42c-1.89,0-3.42,1.53-3.42,3.42c0,1.89,1.53,3.42,3.42,3.42c1.89,0,3.42-1.53,3.42-3.42
              C48.03,11.95,46.5,10.42,44.61,10.42z"/>
            <path class="insta-2" d="M29.41,14.8c-7.92,0-14.37,6.44-14.37,14.37c0,7.92,6.44,14.37,14.37,14.37c7.92,0,14.37-6.44,14.37-14.37
              C43.77,21.25,37.33,14.8,29.41,14.8z M29.41,38.37c-5.07,0-9.2-4.13-9.2-9.2s4.13-9.2,9.2-9.2c5.07,0,9.2,4.13,9.2,9.2
              S34.48,38.37,29.41,38.37z"/>
            <path class="insta-2" d="M40.81,58.34H17.52C7.86,58.34,0,50.48,0,40.81V17.52C0,7.86,7.86,0,17.52,0h23.29
              c9.66,0,17.52,7.86,17.52,17.52v23.29C58.34,50.48,50.47,58.34,40.81,58.34z M17.52,5.49c-6.64,0-12.03,5.4-12.03,12.03v23.29
              c0,6.64,5.4,12.03,12.03,12.03h23.29c6.64,0,12.03-5.4,12.03-12.03V17.52c0-6.64-5.4-12.03-12.03-12.03H17.52z"/>
          </g>
          </g>
          </g>
          </svg>

        </span>
        <span
          class:text-white={white}
          class="sns"
          on:click={() => navigate("https://twitter.com/KONNECT_KCT")}
        >
          <svg
            width={`${r * 30}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 95.79 77.84"
            ><defs
              ><style>
                .twitter-1 {
                  fill: #bababa;
                }
              </style></defs
            ><g id="Layer_2" data-name="Layer 2"
              ><g id="Layer_1-2" data-name="Layer 1"
                ><path
                  class="twitter-1"
                  d="M95.79,9.21a39.26,39.26,0,0,1-11.29,3.1A19.69,19.69,0,0,0,93.14,1.44,39.6,39.6,0,0,1,80.66,6.21a19.66,19.66,0,0,0-34,13.44,20,20,0,0,0,.51,4.48A55.78,55.78,0,0,1,6.67,3.6a19.67,19.67,0,0,0,6.08,26.23,19.57,19.57,0,0,1-8.9-2.45v.24A19.66,19.66,0,0,0,19.61,46.89a19.72,19.72,0,0,1-8.87.34A19.66,19.66,0,0,0,29.09,60.88a39.4,39.4,0,0,1-24.4,8.41A38.23,38.23,0,0,1,0,69a55.6,55.6,0,0,0,30.12,8.83C66.27,77.84,86,47.9,86,21.93c0-.85,0-1.7-.06-2.54A39.9,39.9,0,0,0,95.79,9.21Z"
                /></g
              ></g
            ></svg
          >
        </span>
        <span
          class:text-white={white}
          class="sns"
          on:click={() => navigate("https://medium.com/@KONNECT_KCT")}
        >
          <svg
            width={`${r * 30}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 88.83 75.09"
            ><defs
              ><style>
                .medium-1 {
                  fill: #bababa;
                }
              </style></defs
            ><g id="Layer_2" data-name="Layer 2"
              ><g id="Layer_1-2" data-name="Layer 1"
                ><path
                  class="medium-1"
                  d="M88.72.88l.11,0V0H66.25l-21,49.26L24.33,0H0V.86l.11,0C4.24,1.81,6.33,3.2,6.33,8.2V66.76c0,5-2.1,6.38-6.22,7.31L0,74.1V75H16.5V74.1l-.11,0c-4.12-.93-6.21-2.32-6.21-7.32V11.6L37.11,75h1.53L66.35,9.83V68.2c-.36,4-2.43,5.17-6.16,6l-.11,0v.85H88.83v-.85l-.11,0c-3.74-.85-5.86-2.07-6.21-6l0-60h0c0-5,2.09-6.39,6.21-7.32"
                /></g
              ></g
            ></svg
          >
        </span>
        <span
          class:text-white={white}
          class="sns"
          on:click={() => navigate("https://pf.kakao.com/_yQxcNb")}
        >
          <svg
            width={`${r * 30}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 84.63 84.63"
            ><defs
              ><style>
                .kakao-1 {
                  fill: #bababa;
                }
                .kakao-2 {
                  fill: #fff;
                }
              </style></defs
            ><g id="Layer_2" data-name="Layer 2"
              ><g id="Layer_1-2" data-name="Layer 1"
                ><rect
                  class="kakao-1"
                  width="84.63"
                  height="84.63"
                  rx="15.04"
                /><path
                  class="kakao-2"
                  d="M42.06,13.13C24,13.13,9.39,24.7,9.39,39c0,9.29,6.2,17.42,15.5,22-.68,2.55-2.48,9.24-2.84,10.67-.44,1.78.66,1.75,1.37,1.27.56-.37,9-6.07,12.58-8.54a40.1,40.1,0,0,0,6.06.45c18,0,32.67-11.57,32.67-25.83S60.1,13.13,42.06,13.13"
                /><path
                  class="kakao-1"
                  d="M28.91,31.35H19.36a1.63,1.63,0,1,0,0,3.25h3.11V46.05a1.57,1.57,0,0,0,.46,1.12,1.56,1.56,0,0,0,1.12.46h.35A1.59,1.59,0,0,0,26,46.05V34.6h2.93a1.63,1.63,0,1,0,0-3.25Z"
                /><path
                  class="kakao-1"
                  d="M51.87,44.58H47.43V32.89a1.76,1.76,0,1,0-3.52,0v12.6a2.46,2.46,0,0,0,0,.28,2.64,2.64,0,0,0,0,.28,1.47,1.47,0,0,0,1.47,1.48h6.49a1.48,1.48,0,1,0,0-3Z"
                /><path
                  class="kakao-1"
                  d="M66.07,45.11l-4.95-6.5,4.47-4.47a1.55,1.55,0,1,0-2.19-2.2l-5.54,5.54V32.89a1.76,1.76,0,1,0-3.52,0v13a1.76,1.76,0,0,0,3.52,0v-4l1-1L63.55,47a1.57,1.57,0,0,0,2.21.31A1.59,1.59,0,0,0,66.07,45.11Z"
                /><path
                  class="kakao-1"
                  d="M42.59,45.54l-4.76-13h0a2.34,2.34,0,0,0-2.23-1.38,2.29,2.29,0,0,0-2.32,1.64l-.09.22L28.49,45.54a1.58,1.58,0,0,0,3,1l.81-2.31H38.8l.81,2.31a1.58,1.58,0,1,0,3-1Zm-9.28-4.22,2.19-6.25h.07l2.19,6.24Z"
                /></g
              ></g
            ></svg
          >
        </span>
        <span
          class:text-white={white}
          class="sns"
          on:click={() => navigate("https://blog.naver.com/konnect_finance")}
        >
          <svg
            width={`${r * 30}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 91.73 84.05"
            ><defs
              ><style>
                .naver-1 {
                  fill: #bababa;
                }
              </style></defs
            ><g id="Layer_2" data-name="Layer 2"
              ><g id="Layer_1-2" data-name="Layer 1"
                ><polygon
                  class="naver-1"
                  points="60.44 0 60.44 42.41 31.4 0 0 0 0 84.05 31.29 84.05 31.29 41.64 60.34 84.05 91.73 84.05 91.73 0 60.44 0"
                /></g
              ></g
            ></svg
          >
        </span>
        <span
          class:text-white={white}
          class="sns"
          on:click={() => alert("getting ready!")}
        >
          <svg
            width={`${r * 30}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 110.58 84.3"
          >
            <defs>
              <style>
                .discord-1 {
                  fill: #333333;
                }
              </style>
            </defs>
            <g id="Layer_2" data-name="Layer 2">
              <g id="Layer_1-2" data-name="Layer 1">
                <path
                  class="discord-1"
                  d="M93.65,7a91.2,91.2,0,0,0-22.8-7A66.25,66.25,0,0,0,68,6a82.55,82.55,0,0,0-25.3,0,56,56,0,0,0-3-6,86.3,86.3,0,0,0-22.8,7.1C2.45,28.6-1.45,49.5.45,70.2a90,90,0,0,0,28,14.1,65,65,0,0,0,6-9.7,54.1,54.1,0,0,1-9.4-4.5c.8-.6,1.5-1.2,2.3-1.8a65.37,65.37,0,0,0,56,0c.8.6,1.5,1.2,2.3,1.8a55,55,0,0,1-9.5,4.5,65,65,0,0,0,6,9.7,91.11,91.11,0,0,0,28-14.1C112.35,46.2,106.15,25.4,93.65,7ZM36.85,57.4c-5.5,0-9.9-5-9.9-11.1s4.4-11.2,9.9-11.2,10,5,10,11.2S42.45,57.4,36.85,57.4Zm36.8,0c-5.5,0-9.9-5-9.9-11.1s4.4-11.2,9.9-11.2,10,5,9.9,11.2S79.15,57.4,73.65,57.4Z"
                />
              </g>
            </g>
          </svg>
        </span>
      </div>

      <div style:color={white ? 'white': 'black'} class="company-info row text-right font-roboto text-center">
        <span>Head</span>
        <span>CDF Switzerland GmbH</span>
        <div>
          CDF SWITZERLAND GMBH C/O ABAFIN TREUHAND
          <br>
          AGBAARERSTRASSE 82 6300 ZUG
          <br>
          contact@konnect.finance
        </div>
      </div>
      <div style:color={white ? 'white': 'black'} class="company-info row text-right font-roboto text-center">
        <span>Korea Branch</span>
        <span>씨디에프스위치랜드 유한책임회사(CDF Switzerland GmbH)</span>
        <div>
          대표자 정용석
          <br>
          사업자등록번호 518-84-00025
        </div>
      </div>
    </div>
    <div class="row footer-box mt-3">
      <div>
        <span class="copyright font-roboto">ⓒ Copyright 2022 KCT All rights are reserved.</span>
      </div>
    </div>
  </div>
</section>
<!------------------------------------------->
<!----------------Style----------------------->

<!------------------------------------------->
<style>
  .copyright {
    font-size: 1vw;
    color: #a0a0a0;
  }
  .company-info {
      font-size: 1vw;
  }
  .tele-1, .insta-1, .twitter-1, .medium-1, .kakao-1, .naver-1, .discord-1 {
    fill: var(--type) !important;
  }

  .insta-2 {
    fill: var(--type) !important;
  }
  
  .tele-2, .kakao-2 {
    fill: var(--type2) !important;
  }
  #footer {
    /* width: 1320px; */
    width: 100%;
    position: relative;
  }

  .footer-box {
  }

  .footer-container {
    /* padding-right: 5vw; */
    margin: auto;
    bottom: 0;
    position: absolute;
    width: 100%;
    text-align: center;
  }

  .footer-box i {
    transform: scale(1.8, 1);
  }

  .sns {
    font-size: 4vw;
    padding: 0 2vw;
  }
</style>
